import React, { useContext, useEffect } from 'react';

import Loading from 'components/Loading';
import MetricCacheContext from 'contexts/MetricCacheContext';

const AllMetricsGate = ({ children }: { children: React.ReactNode }) => {
  const {
    requestAllNormalMetrics,
    requestAllCompoundMetrics,
    allMetricsLoaded,
  } = useContext(MetricCacheContext);

  useEffect(() => {
    requestAllNormalMetrics();
    requestAllCompoundMetrics();
  }, [requestAllNormalMetrics, requestAllCompoundMetrics]);

  if (!allMetricsLoaded) {
    return <Loading />;
  }

  return <>{children}</>;
};

export default AllMetricsGate;
